import { Icon } from '../icons/registry';
import { useIconSystem } from '../../hooks/useIconSystem';
/**
 * InlineAction — a quiet, full-width secondary action row for Today.
 *
 * The coach-entry design pass demoted Today's marine FABs (so the CoachFab owns
 * the single elevated layer): "Log a race" and the first-run "Start setup" now
 * render inline in the content as ghost rows (mirrors desktop QuickActions'
 * secondary `.action` idiom) instead of competing bottom-right FABs.
 */
import { Link } from 'react-router-dom';
import styles from './InlineAction.module.css';

export function InlineAction({
  to,
  label,
  sub,
}: {
  to: string;
  label: string;
  /** Optional trailing muted hint. */
  sub?: string;
}) {
  const iconsOn = useIconSystem();
  return (
    <Link to={to} className={styles.act}>
      {/* A2 · R7 — `sys.plus` @14, optical. */}
      <span className={styles.plus} aria-hidden="true">
        {iconsOn ? (
          <Icon name="sys.plus" size={14} />
        ) : (
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinecap="round"
          >
            <path d="M7 2v10M2 7h10" />
          </svg>
        )}
      </span>
      <span className={styles.label}>{label}</span>
      {sub ? <span className={styles.sub}>{sub}</span> : null}
    </Link>
  );
}
